module.exports = __webpack_public_path__ + "static/media/kitchen.bca51d47.png";